import { createSelector } from "reselect";

import { selectSelectedEntityId } from "../entity/selectors";
import { workspaceConfigEntityAdapter, workspaceConfigSlice } from "./slice";

const selectWorkspaceConfigState = (state) => state[workspaceConfigSlice.name];

export const selectWorkspaceConfigDetailsBySelectedEntityId = createSelector(
  selectWorkspaceConfigState,
  selectSelectedEntityId,
  (workspaceConfigState, entityId) =>
    workspaceConfigEntityAdapter.getSelectors().selectById(workspaceConfigState, entityId) || null,
);

export const selectWorkspaceConfigDetailsByEntityId = createSelector(
  selectWorkspaceConfigState,
  (state, props) => ({ entityId: props.entityId }),
  (workspaceConfigState, { entityId }) =>
    workspaceConfigEntityAdapter.getSelectors().selectById(workspaceConfigState, entityId) || null,
);

export const selectWorkspaceConfigAssignedCategories = createSelector(
  selectWorkspaceConfigDetailsByEntityId,
  (workspaceConfigDetails) => workspaceConfigDetails?.categories || [],
);
